module.exports = __webpack_public_path__ + "img/db_icon_coin.968051ce.png";